<template>

  <v-card>

    <v-card
      class="d-flex"
      :color="color"
      dark
    >

      <v-card-title
        class="subtitle-2 font-weight-bold"
      >
        {{ task }}
      </v-card-title>

      <v-spacer></v-spacer>

      <v-btn
        fab
        small
        color="#333333"
        @click.native="showHint()"
        class="ma-1 hints-btn"
        v-if="hints.length > 0 && hintsRevealCount < hints.length"
      >

        <v-icon
          :color="hintsRevealCount < hints.length ? 'yellow accent-3' : ''"
        >
          mdi-lightbulb-on
        </v-icon>

        <v-badge
          color="purple accent-7"
          class="mb-3"
          :content="hints.length - hintsRevealCount"
        >
        </v-badge>

      </v-btn>

      <v-icon
          dark
          left
          class="mx-5"
          size="8"
          @click.stop="dismissQuestion()"
      >
        mdi-checkbox-blank-circle
      </v-icon>
    
    </v-card>

    <v-card flat>
      <v-card-text class="text--primary">

        <div class="px-1 pb-2">{{ content }}</div>

        <div
          v-if="hintsRevealCount > 0"
        >
          <v-alert
            text
            dense
            color="teal"
            icon="mdi-lightbulb-on"
            border="left"
            v-for="(hint, index) in hints"
            :key="index"
            :value="hintsRevealCount > index"
            transition="scale-transition"
          >
            {{ hint }}
          </v-alert>
        </div>

        <div
          v-else
          class="my-2"
        >
        </div>

        <div class="d-flex">
          <v-text-field
            dense
            label="Enter Flag to Verify"
            outlined
            single-line
            hide-details="auto"
            :success="this.$store.getters.getSolvedQuestionsList.includes(index)"
            :success-messages="this.$store.getters.getSolvedQuestionsList.includes(index) ? successMsg : ''"
            :error="!this.$store.getters.getSolvedQuestionsList.includes(index) && flagError"
            :error-messages="!this.$store.getters.getSolvedQuestionsList.includes(index) && flagError ? errorMsg : ''"
            :loading="checkingFlag"
            :rules="[rules.isEmpty]"
            hint=""
            v-model.trim="flag"
            class="body-2 mr-1"
            append-icon="mdi-flag"
          >
          </v-text-field>

          <v-btn
            :class="!this.$store.getters.getSolvedQuestionsList.includes(index) ? 'success ml-1' : ''"
            :text="this.$store.getters.getSolvedQuestionsList.includes(index)"
            :color="this.$store.getters.getSolvedQuestionsList.includes(index) ? 'success' : ''"
            @click="verifyFlag()"
          >
            {{ this.$store.getters.getSolvedQuestionsList.includes(index) ? "Verified" : "Verify" }}
            <v-icon v-if="this.$store.getters.getSolvedQuestionsList.includes(index)" right>
              mdi-checkbox-marked-circle
            </v-icon>
          </v-btn>

        </div>

      </v-card-text>
    </v-card>

  </v-card>

</template>

<script>

export default {
  name: "QuestionCard",
  props: {
    index: Number,
    content: String,
    successMsg: String,
    errorMsg: String,
    doneCheckingFlag: Boolean,
    flagError: Boolean,
    clearFlag: Boolean,
    color: String,
    task: String,
    hints: Array,
  },
  data() {
    return {
      flag: null,
      tab: "tab-1",
      rules: {
        isEmpty: flag => (flag == null || (flag && flag.length !== 0)) || "Empty flag not allowed!"
      },
      error: null,
      hintsRevealCount: 0,
    };
  },
  created() {
    this.flag = this.$store.getters.getFlags[this.index];
    // this.hints = this.$store.getters.getQuestionsList[this.index]["hints"];
  },
  watch: {
    clearFlag(newVal, oldVal) {

      this.tab = "tab-1";

      if (oldVal !== newVal && newVal === true) {
        this.flag = this.$store.getters.getFlags[this.index];
      }

    },
  },
  methods: {

    showHint() {

      if (this.hintsRevealCount >= this.hints.length) {
        return;
      }

      this.hintsRevealCount++;

    },
    dismissQuestion() {
      this.$emit("dismiss-question-card");

      /* eslint-disable no-console */

      console.log("Index: " + this.index);
      console.log("SolvedQuestionsList: " + this.$store.getters.getSolvedQuestionsList);
      console.log("Response: " + this.$store.getters.getSolvedQuestionsList.includes(this.index));
      console.log("Get Flag At Index: " + this.$store.getters.getFlags[this.index]);

      console.log("FLAG IS : " + this.flag);
      console.log("STORED FLAG IS : " + this.$store.getters.getFlags[this.index]);

      /* eslint-enable no-console */

      if (!this.$store.getters.getSolvedQuestionsList.includes(this.index)) {
        this.flag = null;
        return;
      }

      if (this.$store.getters.getFlags[this.index] === null) {
        this.$store.dispatch("addToFlags", { "flag": this.flag, "index": this.index });
      }

    },
    verifyFlag() {
      this.$emit("verify-flag", this.flag);
    },
  },
  computed: {
    checkingFlag() {
      if (this.doneCheckingFlag === null) {
        return false;
      }
      return !this.doneCheckingFlag;
    },
    getSolvedFlag() {
      return this.$store.getters.getFlags[this.index];
    },
  }
};
</script>